












































































































































import {
    defineComponent,
    computed,
    toRef,
    onMounted,
    PropType,
} from '@vue/composition-api';
import EventCardTitle from '@modules/shared/event/EventCardTitle.vue';
import EventCardLabel from '@modules/shared/event/EventCardLabel.vue';
import EventTime from '@modules/shared/event/EventTime.vue';
import EventCompetitor from '@modules/shared/event/EventCompetitor.vue';
import EventCardDivider from '@modules/shared/event/EventCardDivider.vue';
import ScoreWidget from '@modules/shared/event/ScoreWidget.vue';
import TicketEventCondensed from './TicketEventCondensed.vue';
import SuperBetsDetails from '@modules/eventGrid/components/markets/superBets/SuperBetsDetails.vue';
import FixSwitch from '@modules/shared/betSlip/FixSwitch.vue';
import TicketSelectionOdd from './TicketSelectionOdd.vue';
import PriceBoostOddValue from '@src/federations/sportOffer/price-boost/components/PriceBoostOddValue.vue';
import { useCompetitorStats } from '@shared/event/composeable/useCompetitorStats';
import {
    BetSlipOddLeg,
    EventStatus,
    OddStatus,
    OfferEventCondensed,
} from '@superbet-group/web.types';
import {
    isSuperbetByName,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import { SportOfferDataStore } from '@store/modules/data/sportOffer';
import OfferEvent from '@core/models/offer/OfferEvent';

import { useEventDisplayDetails } from './composeable/useEventDisplayDetails';
import { SdsIcon } from '@superbet-group/web.lib.ui-components';

export default defineComponent({
    name: 'TicketSelectionCard',

    props: {
        ticketEvent: {
            type: Object as PropType<OfferEventCondensed>,
            required: true,
        },
        e2eClass: {
            type: String,
            required: false,
            default: '',
        },
        // For remove double generosity feature we will position SA label differently
        isRemoveDoubleGenerosityEnabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        isPriceBoost: {
            type: Boolean,
            required: false,
            default: false,
        },
        originalPrice: {
            type: Number,
            required: false,
            default: null,
        },
    },

    setup(props) {
        const ticketEvent = toRef(props, 'ticketEvent');

        const sportOfferStore = useVuexStore<SportOfferDataStore>('data/sportOffer');

        const eventsMap = sportOfferStore.getter('eventsMap');
        const getEventById = sportOfferStore.action('getEvent');

        const event = computed(() => {
            return eventsMap.value[ticketEvent.value.eventId];
        });

        const eventTeams = computed(() => {
            return {
                homeTeam: event.value?.team1Name,
                awayTeam: event.value?.team2Name,
            };
        });

        const statusIconName = computed(() => {
            switch (ticketEvent.value.status) {
                case EventStatus.win:
                    return 'status-checkmark';
                case EventStatus.lost:
                    return 'status-close';
                case EventStatus.refund:
                    return 'status-refund';
                default:
                    return '';
            }
        });

        const legs = computed(() => ticketEvent.value.eventComponents?.map<Pick<BetSlipOddLeg, 'name' | 'status'>>(
            ({ market, oddComponent }) => ({
                name: `${market.name}: ${oddComponent.name}`,
                status: oddComponent.oddStatus ?? OddStatus.Unspecified,
            }),
        ));

        const { isLive, isFirstLeading, isSecondLeading, isFirstServing, isSecondServing }
            = useCompetitorStats(event);

        function isFullyLoaded(event: OfferEvent): boolean {
            return event && event.containsFullOddList();
        }

        onMounted(() => {
            if (isFullyLoaded(event.value)) {
                return;
            }

            getEventById(parseInt(ticketEvent.value.eventId, 10));
        });

        return {
            ...useEventDisplayDetails(ticketEvent, event),
            superBetsLegs: computed(() =>
                isSuperbetByName(ticketEvent.value.market.name)
                    ? ticketEvent.value.market.name
                    : ticketEvent.value.odd.name,
            ),
            event,
            isLive,
            isFirstLeading,
            isSecondLeading,
            isFirstServing,
            isSecondServing,
            statusIconName,
            legs,
            eventTeams,
        };
    },

    components: {
        EventCardTitle,
        EventCardLabel,
        EventTime,
        EventCompetitor,
        EventCardDivider,
        ScoreWidget,
        SuperBetsDetails,
        FixSwitch,
        TicketSelectionOdd,
        TicketEventCondensed,
        SdsIcon,
        PriceBoostOddValue,
    },
});
